import * as actionTypes from '../../actions/actionTypes';

const validationActionTypes = actionTypes.validationActionTypes;

/**
 * Update errors from validation
 * @param {object} state
 * @param {object} action
 * @return {object} state
 */
export function VALIDATION_errors(state = {}, action) {
	switch (action.type) {
		case validationActionTypes.UPDATE_VALIDATION_ERRORS:
			const nextState = Object.assign({}, state);

			for (let key in action.errors) {
				if (action.errors.hasOwnProperty(key)) {
					const errors = action.errors[key];

					if (errors.length) {
						nextState[key] = errors;
					} else {
						delete nextState[key];
					}
				}
			}
			return nextState;

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ../~/@jg/justgiving-app-login/app/reducers/reducers/validationReducers.js